// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as WifiOffComponent} from './WifiOff.svg';

import Icon, { TIconProps } from '../Icon';

export const IconWifiOff = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <WifiOffComponent/>
  </Icon>
));
